// tslint:disable
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
export class ClaimAdjudicationCodeModel {
    static getAttributeTypeMap() {
        return ClaimAdjudicationCodeModel.attributeTypeMap;
    }
}
ClaimAdjudicationCodeModel.discriminator = undefined;
ClaimAdjudicationCodeModel.attributeTypeMap = [
    {
        "name": "carc",
        "baseName": "carc",
        "type": "string"
    },
    {
        "name": "rarc",
        "baseName": "rarc",
        "type": "string"
    }
];
//# sourceMappingURL=claimAdjudicationCodeModel.js.map